import { Talent } from "../../Classes";

export default [
  null,
  new Talent(
    "Kill Shot",
    "ability_hunter_assassinate2",
    [
      "You attempt to finish the wounded target off, firing a long range attack dealing 150% weapon damage plus 70. Kill Shot can only be used on enemies that have 20% or less health.",
    ],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    "115 Mana",
    "8 - 35 yd range",
    "2 sec cast",
    "10 sec cooldown",
    null,
    { isNew: true, isChanged: false, isMoved: false },
  ),
  null,
  null,
  null,
];
